export const DURATIONS = {
  micro: 0.2,
  component: 0.55,
  scene: 1,
};

export const MICRO = DURATIONS.micro;
export const COMPONENT = DURATIONS.component;
export const SCENE = DURATIONS.scene;